import React, { Fragment } from 'react';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes.js';
import { preventerTools } from '@utils/tools/preventerTools';
import { FormattedMessage } from 'react-intl';
const CaliforniaFooter = props => {

    const {
        environment,
        environment: {
            coverageYear,
            devEnvironment,
            anonymous,
            impersonation,
            links: {
                SIGNUP_INDIVIDUAL: individual,
                SIGNUP_AGENCY: agency,
                SIGNUP_ADMIN_STAFF1: adminStaff1,
                SIGNUP_ADMIN_STAFF2: adminStaff2,
                SIGNUP_AGENT_BROKER: agentBroker,
                SIGNUP_ENROLLMENT_ENTITIES: enrollmentEntities,
                SIGNUP_ENROLLMENT_COUNSELOR: enrollmentCounselor
            }
        },
    } = props;
    const {
        role,
        externalHouseholdCaseId,
        firstName,
        lastName
    } = preventerTools.provideObject(environment.user);

    const {
        name,
        externalHouseholdCaseId: householdId
    } = preventerTools.provideObject(environment.impersonationDetails);

    const consumerName = impersonation ? name : <Fragment>{ firstName } { lastName }</Fragment>;
    const caseId = impersonation ? householdId : externalHouseholdCaseId;
    const canViewFooter = (!anonymous && impersonation) || (!anonymous && role === ALL_USER_ROLES.INDIVIDUAL);

    return(
        <Fragment>
            <footer id="footer--ca" className="usa-footer gi-footer" role="contentinfo">
                <div className="grid-container gi-footer__container">
                    <div className="usa-footer__primary-section gi-footer__primary-section">
                        { devEnvironment &&
                            <div className="grid-row grid-gap">
                                { !anonymous &&
                                    <div className="usa-footer__logo grid-row mobile-lg:grid-col-6 mobile-lg:grid-gap-2">
                                        <div className="mobile-lg:grid-col-auto" id="copyrights">
                                            <FormattedMessage id='footer.copyright' values={{ coverageYear }}/>
                                        </div>
                                    </div>
                                }
                                <div className="mobile-lg:grid-col-6 desktop:grid-col-6">
                                    <ul className="grid-row grid-gap">
                                        <li className="mobile-lg:grid-col-4 desktop:grid-col-auto usa-footer__primary-content">
                                            <a className="usa-footer__primary-link" data-automation-id="individual" href={individual}><FormattedMessage id='footer.individual'/></a>
                                        </li>
                                        <li className="mobile-lg:grid-col-4 desktop:grid-col-auto usa-footer__primary-content">
                                            <a className="usa-footer__primary-link" data-automation-id="agency" href={agency}><FormattedMessage id='footer.agency'/></a>
                                        </li>
                                        <li className="mobile-lg:grid-col-4 desktop:grid-col-auto usa-footer__primary-content">
                                            <a className="usa-footer__primary-link" data-automation-id="adminStaff1" href={adminStaff1}><FormattedMessage id='footer.admin_staff' values={{ num: 1 }}/></a>
                                        </li>
                                        <li className="mobile-lg:grid-col-4 desktop:grid-col-auto usa-footer__primary-content">
                                            <a className="usa-footer__primary-link" data-automation-id="adminStaff2" href={adminStaff2}><FormattedMessage id='footer.admin_staff' values={{ num: 2 }}/></a>
                                        </li>
                                        <li className="mobile-lg:grid-col-4 desktop:grid-col-auto usa-footer__primary-content">
                                            <a className="usa-footer__primary-link" data-automation-id="agentBroker" href={agentBroker}><FormattedMessage id='footer.agent_broker'/></a>
                                        </li>
                                        <li className="mobile-lg:grid-col-4 desktop:grid-col-auto usa-footer__primary-content">
                                            <a className="usa-footer__primary-link" data-automation-id="enrollmentEntities" href={enrollmentEntities}><FormattedMessage id='footer.enrollment_entities'/></a>
                                        </li>
                                        <li className="mobile-lg:grid-col-4 desktop:grid-col-auto usa-footer__primary-content">
                                            <a className="usa-footer__primary-link" data-automation-id="enrollmentCounselor" href={enrollmentCounselor}><FormattedMessage id='footer.enrollment_counselor'/></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        }
                        { !devEnvironment &&
                            <div className="grid-row grid-gap">
                                { anonymous &&
                                <div className="mobile-lg:grid-col-12 desktop:grid-col-12">
                                    <div className="mobile-lg:grid-col-auto" id="copyrights">
                                        <FormattedMessage id='footer.copyright' values={{ coverageYear }}/>
                                    </div>
                                </div>
                                }
                                { canViewFooter &&
                                <div className="mobile-lg:grid-col-12 desktop:grid-col-12">
                                    <ul className="grid-row grid-gap float-right">
                                        <li className="mobile-lg:grid-col-6 desktop:grid-col-auto usa-footer__primary-content text-right">
                                            <FormattedMessage id='common.non_internationalized_text' values={ { text: consumerName  } }/>
                                        </li>
                                        <li className="mobile-lg:grid-col-1 desktop:grid-col-auto usa-footer__primary-content">
                                            &nbsp; | &nbsp;
                                        </li>
                                        <li className="mobile-lg:grid-col-4 desktop:grid-col-auto usa-footer__primary-content text-left">
                                            <FormattedMessage id='footer.case_number' values={{ caseId }}/>
                                        </li>
                                    </ul>
                                </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            </footer>
        </Fragment>

    );
};

export default CaliforniaFooter;
